import { styled } from "@styles";
import { Accordion, Card, ButtonGroup } from "react-bootstrap";

export const Wrapper = styled(Accordion)``;

export const CheckoutAddressCard = styled(Card)``;

export const CheckoutAddressCardHeader = styled(Card.Header)`
  text-align: center;
`;

export const CheckoutAddressCardHeaderTitle = styled(Accordion.Toggle)`
  text-transform: uppercase;
  font-weight: 700;
`;

export const CheckoutAddressCardCollapse = styled(Accordion.Collapse)``;

export const CheckoutAddressCardBody = styled(Card.Body)``;

export const CheckoutAddressButtonGroup = styled(ButtonGroup)`
  width: 100%;
`;

export const CheckoutAddressAddressCard = styled(Card)`
  border-right: none;
`;

export const CheckoutAddressAddressSelectButton = styled.button`
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-left: none;
`;

export const CheckoutAddressPWithoutMarginNickname = styled.p`
  margin: 0;
  color: #ff3399;
  font-weight: bold;
`;

export const CheckoutAddressPWithoutMargin = styled.p`
  margin: 0;
`;

export const CheckoutAddressAddAddressButton = styled.button`
  color: gray;
  border-color: #ddd;
  text-transform: none;
`;